import { render, staticRenderFns } from "./IndemnityTemplateDeleteModal.vue?vue&type=template&id=1aa220cc&scoped=true"
import script from "./IndemnityTemplateDeleteModal.vue?vue&type=script&lang=js"
export * from "./IndemnityTemplateDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityTemplateDeleteModal.vue?vue&type=style&index=0&id=1aa220cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa220cc",
  null
  
)

export default component.exports